import { Box, Button, Dialog, IconButton, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SkipNextOutlinedIcon from '@mui/icons-material/SkipNextOutlined';

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    stepName?: string;
    comment: string;
    onCommentChange: (value: string) => void;
    isActionInProgress: boolean;
    classes?: any;
}

const ConfirmSkipStepDialog = ({ open, onClose, onConfirm, stepName, comment, onCommentChange, isActionInProgress, classes }: Props) => {
    const isCommentEmpty = !comment.trim();
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{ sx: { borderRadius: 2, p: 0 } }}
        >
            <Box sx={{ p: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <SkipNextOutlinedIcon sx={{ color: '#D8010B', fontSize: 20 }} />
                        <Typography variant="h6" className={classes?.labelNoto16Bold500_hh}>Skip Step</Typography>
                    </Box>
                    <IconButton onClick={onClose} size="small" disableRipple sx={{ color: '#666' }}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Typography variant="body1" className={classes?.labelNoto14Bold400_hh} sx={{ mb: 2, color: '#333', lineHeight: 1.5 }}>
                    Are you sure you want to skip {stepName?.toLowerCase() || 'this step'}?
                </Typography>
                <Typography variant="body2" className={classes?.labelNoto14Bold400_hh} sx={{ mb: 1, color: '#333' }}>
                    Comment <Box component="span" sx={{ color: '#D8010B' }}>*</Box>
                </Typography>
                <TextField
                    autoFocus
                    fullWidth
                    multiline
                    rows={3}
                    placeholder="Enter reason for skipping this step..."
                    value={comment}
                    onChange={(e) => onCommentChange(e.target.value)}
                    variant="outlined"
                    sx={{ mb: 3, '& .MuiOutlinedInput-root': { borderRadius: 2, backgroundColor: '#fafafa' } }}
                />
                <Box sx={{ display: 'flex', gap: 1.5, justifyContent: 'center' }}>
                    <Button onClick={onClose} variant="outlined" disableRipple className={classes?.whiteButton} sx={{ width: 126, minWidth: 126, height: 39, fontSize: '20.8px', borderRadius: '4px', borderWidth: '1px', opacity: 1, gap: '10px', p: '10px', border: '1px solid #000000' }}>Cancel</Button>
                    <Button
                        onClick={onConfirm}
                        variant="contained"
                        disableRipple
                        disabled={isActionInProgress || isCommentEmpty}
                        sx={{
                            width: 126,
                            minWidth: 126,
                            height: 39,
                            fontSize: '20.8px',
                            borderRadius: '4px',
                            opacity: 1,
                            gap: '10px',
                            p: '10px',
                            textTransform: 'none',
                            background: '#D8010B',
                            color: '#fff',
                            '&:hover': { background: '#b50101' },
                            '&:disabled': { background: '#bdbdbd', color: '#fff' },
                        }}
                    >
                        Confirm
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
}

export default ConfirmSkipStepDialog;
